var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('select',{staticClass:"device-select",domProps:{"value":_vm.activeDeviceId},on:{"change":_vm.handleChange}},_vm._l((_vm.deviceList),function(item,index){return _c('option',{key:index,domProps:{"value":item.deviceId}},[_vm._v(_vm._s(item.label))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }